import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchTaskEvents } from "./api";
import type { TaskStatusEventResponse } from "./api";

// Лог переходов status для TaskDetailPage. Org-scoped запрос (см.
// `src/query/scope.ts`).
//
// Append-only журнал из task_status_event; инвалидируется
// одновременно с useTask по SSE-событию.
export function useTaskEvents(
  taskId: string,
): UseQueryResult<TaskStatusEventResponse[], Error> {
  return useOrgScopedQuery<TaskStatusEventResponse[]>({
    key: ["task-events", taskId],
    queryFn: () => fetchTaskEvents(taskId),
    retry: false,
  });
}
